export default __webpack_public_path__ + "static/media/cthenic.0dee1beb.jpg";